<template>
  <div class="paperlist-container">
    <div class="page-header">
      <div class="header-left">
        <button @click="goHome" class="home-btn">
          <span class="home-icon">🏠</span>
          <span class="home-text">返回首页</span>
        </button>
        <h1 class="page-title">📋 取件表任务列表</h1>
      </div>
      <div class="header-actions">
        <button @click="inputDialogToggle" class="new-task-btn">
          <span class="btn-icon">✨</span>
          <span>新建任务</span>
        </button>
      </div>
    </div>
    
    <div class="pdf-tip-container">
      <i class="fas fa-info-circle"></i>
      <span class="tip-text">如果您的说明书不是PDF文件，请点击</span>
      <a href="http://assistant.muuedu.com/imagetopdf" target="_blank" class="tip-link">【这里】</a>
      <span class="tip-text">把图片合成PDF</span>
    </div>
    
    <!-- 替换next-table为标准HTML表格 -->
    <table class="task-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>模板</th>
          <th>创建时间</th>
          <th>状态</th>
          <th>页数</th>
          <th>是否公开</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="task in tasklist" :key="task.TemplateID">
          <td>{{ task.TemplateID }}</td>
          <td>{{ task.TemplateName }}</td>
          <td>{{ task.FirstCreated }}</td>
          <td><span :class="'status-' + task.Flag">{{ task.Flag }}</span></td>
          <td>{{ task.ProjectCount }}</td>
          <td>
            <label class="switch" :class="{ 'switch-disabled': task.Flag !== '已完成' }">
              <input type="checkbox" v-model="task.Status" @change="togglePublicStatus(task)" :disabled="task.Flag !== '已完成'">
              <span class="slider round"></span>
            </label>
          </td>
          <td>
            <button @click="showpagelist(task)" class="action-btn edit-btn">编辑</button>
            <button @click="tosummarypage(task)" class="action-btn summary-btn">项目汇总</button>
            <button @click="deletepdf(task)" class="action-btn delete-btn">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- 分页组件 -->
    <div class="pagination-container">
      <div class="pagination-info">
        <span>共 {{ totalItems }} 条记录，第 {{ currentPage }} / {{ totalPages }} 页</span>
      </div>
      <div class="pagination-controls">
        <button @click="prevPage" :disabled="currentPage <= 1" class="pagination-btn">
          <span>⬅️</span>
          <span>上一页</span>
        </button>
        <span class="page-numbers">
          <button 
            v-for="page in displayedPages" 
            :key="page" 
            @click="goToPage(page)"
            :class="{ 'active': page === currentPage, 'page-btn': true }"
          >
            {{ page }}
          </button>
        </span>
        <button @click="nextPage" :disabled="currentPage >= totalPages" class="pagination-btn">
          <span>下一页</span>
          <span>➡️</span>
        </button>
      </div>
    </div>
    
    <!-- 选择操作弹窗 -->
    <!-- 已移除，操作按钮已移至表格每行最后一列 -->
    
    <!-- 显示每页数据弹窗 -->
    <div v-if="showPageListPopup" class="popup-overlay" @click="closepagelistpopup">
      <div class="popup-content page-list-popup" @click.stop>
        <div style="padding: 5px;background-color: #fff;">
          <table class="page-table">
            <thead>
              <tr>
                <th>id</th>
                <th>模板</th>
                <th>页数</th>
                <th>更新时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id" @click="rowClick(item)">
                <td>{{ item.id }}</td>
                <td>{{ item.name || '--' }}</td>
                <td>{{ item.page }}</td>
                <td>{{ item.updatflag || '--' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button @click="closepagelistpopup" class="btn btn-secondary">关闭</button>
      </div>
    </div>
    
    <!-- 新建弹窗 -->
    <div v-if="showInputDialog" class="popup-overlay" @click="closeInputDialog">
      <div class="dialog-content" @click.stop>
        <div class="dialog-header">
          <h3>新建任务</h3>
        </div>
        <div class="dialog-body">
          <div class="form-container">
            <div class="form-item">
              <div class="form-label">模板名</div>
              <div class="input-wrapper">
                <input 
                  class="form-input"
                  v-model="modelname" 
                  placeholder="请输入名称"
                />
              </div>
            </div>
            
            <div class="form-item">
              <div class="form-label">类型</div>
              <div class="picker-wrapper">
                <select v-model="modeltype" @change="bindPickerChange" class="form-input">
                  <option v-for="(item, index) in array" :key="index" :value="item">{{ item || '请选择类型' }}</option>
                </select>
              </div>
            </div>
            
            <div class="form-item">
              <div class="form-label">是否开启版面分析</div>
              <div class="switch-wrapper">
                <label class="switch">
                  <input type="checkbox" v-model="identifybtn" true-value="1" false-value="0" @change="switch1Change">
                  <span class="slider"></span>
                </label>
                <span class="switch-label">{{ identifybtn == 1 ? '开启' : '关闭' }}</span>
              </div>
              <div class="form-tip">
                <i class="fas fa-info-circle"></i>
                <span>对于文字较多的说明书（如frs、mgex、PG），建议关闭此功能以获得更好的识别效果</span>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <button @click="closeInputDialog" class="btn btn-secondary">取消</button>
          <button @click="choosePdfFile" class="btn btn-primary">确认</button>
        </div>
      </div>
    </div>
    
    <!-- 提示框 -->
    <div v-if="showAlertDialog" class="popup-overlay" @click="closeAlertDialog">
      <div class="dialog-content" @click.stop>
        <div class="dialog-header">
          <h3>注意</h3>
        </div>
        <div class="dialog-body">
          <p>确定删除项目记录吗？</p>
        </div>
        <div class="dialog-footer">
          <button @click="closeAlertDialog" class="btn btn-secondary">关闭</button>
          <button @click="dialogConfirm" class="btn btn-danger">同意</button>
        </div>
      </div>
    </div>
    
    <!-- 隐藏的文件选择器 -->
    <input type="file" ref="fileInput" accept=".pdf" style="display: none" @change="handleFileChange" />
  </div>
</template>

<script>
import { showToast, navigateTo, getStorageSync } from '@/utils/uni-app'
import api from '@/api'

export default {
  name: 'PaperList',
  data() {
    return {
      modelname: "我的模板名称",
      modeltype: "选择类型",
      identifybtn: 0, // 0代表不识别定位点，1代表识别定位点
      url: "", // 上传pdf
      filePath: "",
      list: [{
        id: 1,
        name: "",
        page: "",
        testinfo: "",
      }],
      tasklist: [{
        AdminID: 1,
        FirstCreated: "",
        LastCreated: "",
        TemplateName: "",
        ProjectCount: 1,
        TemplateID: 1,
      }],
      array: ["", "HG", "HGUC", "MG", "MG 1", "RG 1", "RG限定", "PG", "PGU", "国模", "KO"],
      index: 0,
      activeid: 0,
      TemplateID: 0, // 第几个项目
      showPageListPopup: false,
      showInputDialog: false,
      showAlertDialog: false,
      // 分页相关数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0
    }
  },
  computed: {
    // 计算显示的页码
    displayedPages() {
      const pages = []
      const start = Math.max(1, this.currentPage - 2)
      const end = Math.min(this.totalPages, start + 4)
      
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      
      return pages
    }
  },
  mounted() {
    // 检查登录状态
    const token = getStorageSync('token')
    if (!token) {
      navigateTo('/login')
    } else {
      this.getMyTask(1)
    }
  },
  methods: {
    closepagelistpopup() {
      this.showPageListPopup = false
    },
    closeInputDialog() {
      this.showInputDialog = false
    },
    closeAlertDialog() {
      this.showAlertDialog = false
    },
    toeditorpage() {
      this.$router.push("/editor?id=" + this.activeid)
    },
    tosummarypage(task) {
      this.$router.push("/summary?id=" + task.TemplateID)
    },
    switch1Change(e) {
      console.log('switch1 触发 change 事件，当前值为', this.identifybtn)
      // 由于使用了v-model双向绑定，不需要手动设置值
      // Vue会自动更新identifybtn的值
    },
    taskrowClick(task) {
      // 此方法已不再需要，因为操作已移至表格每行最后一列
      console.log("task click", task.TemplateID)
    },
    showpagelist(task) {
      this.TemplateID = task.TemplateID
      this.getList(1)
      this.showPageListPopup = true
    },
    dialogConfirm() {
      console.log('用户确认')
      const _this = this
      
      api.formPost('/liner/Deletepdf', {
        id: this.TemplateID
      })
        .then(res => {
          let data = res.data
          console.log(data.code)
          if (data.code == 200) {
            _this.getMyTask(1)
          } else {
            showToast({title: "获取失败"})
          }
        })
        .catch(_err => {
          showToast({title: "获取失败"})
        })
      
      this.closeAlertDialog()
    },
    togglePublicStatus(task) {
      this.$loading.show({
        title: '更新中...'
      })
      
      api.formGet('/liner/Setstatus/' + task.TemplateID)
        .then(res => {
          let data = res.data
          if (res.code == 200) {
            showToast({title: "状态更新成功"})
            console.log(task)
            this.getMyTask(1)
          } else {
            // 如果更新失败，恢复开关状态
            task.Status = !task.Status
            showToast({title: "状态更新失败"})
          }
        })
        .catch(_err => {
          // 如果请求失败，恢复开关状态
          task.Status = !task.Status
          showToast({title: "网络错误"})
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    deletepdf(task) {
      this.TemplateID = task.TemplateID
      this.showAlertDialog = true
    },
    rowClick(item) {
      this.activeid = item.id
      this.$router.push("/editor?id=" + item.id)
    },
    getMyTask(page) { // 获取我的任务
      const _this = this
      this.currentPage = page || 1
      
      api.formPost('/liner/GetMyTasklist', {
        page: this.currentPage,
        limit: this.pageSize,
      })
        .then(res => {
          let data = res.data
          console.log(res)
          if (res.code == 200) {
            console.log("112", data.data)
            // 确保每个任务都有isPublic字段，默认为false
            _this.tasklist = data.data.map(task => ({
              ...task,
              isPublic: task.status == 1 ? true : false
            }))
            
            // 更新分页信息
            _this.totalItems = data.total || data.data.length
            _this.totalPages = Math.ceil(_this.totalItems / _this.pageSize)
          } else {
            showToast({title: "获取失败"})
          }
        })
        .catch(_err => {
          showToast({title: "获取失败"})
        })
    },
    // 分页相关方法
    goToPage(page) {
      if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
        this.getMyTask(page)
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.getMyTask(this.currentPage + 1)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.getMyTask(this.currentPage - 1)
      }
    },
    goHome() {
      this.$router.push("/")
    },
    getList(_page) {
      this.list = []
      this.$loading.show();
      const _this = this
      
      api.formPost('/liner/Getpdfpagelist', {
        page: 1,
        id: this.TemplateID
      })
        .then(res => {
          let data = res.data
          if (res.code == 200) {
            console.log(data.data)
            _this.list = data.data
          } else {
            showToast({title: "获取失败"})
          }
        })
        .catch(() => {
          showToast({title: "获取失败"})
        })
        .finally(() => {
          this.$loading.hide()
        })
    },
    bindPickerChange(e) {
      console.log('picker发送选择改变，携带值为', e.target.value)
      this.modeltype = e.target.value
      this.index = this.array.indexOf(this.modeltype)
      console.log('类型为', this.modeltype)
    },
    inputDialogToggle() {
      this.showInputDialog = true
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      
      this.filePath = file
      this.uploadFile(file)
    },
    choosePdfFile() {
      if (this.modeltype == "选择类型" || this.modeltype == "") {
        showToast({
          title: "请选择类型",
          icon: "error"
        })
        return false;
      }
      
      this.closeInputDialog()
      
      // 打开文件选择器
      this.$refs.fileInput.click()
    },
    uploadFile(file) {
      this.$loading.show()
      
      const formData = new FormData()
      formData.append('pdf', file)
      formData.append('name', this.modelname)
      formData.append('type', this.modeltype)
      // 确保identifybtn作为数字类型传递（0或1）
      formData.append('identifybtn', Number(this.identifybtn))
      
      api.upload('/liner/Uploadpdftoimage', formData)
        .then(res => {
          console.log(res.data)
          this.getMyTask(1)
        })
        .catch(err => {
          console.error('文件上传失败！', err)
        })
        .finally(() => {
          this.$loading.hide()
        })
    }
  }
}
</script>

<style scoped>
.paperlist-container {
  padding: 15px;
  position: relative;
  background-color: #f9f9ff;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 2px dashed #e0e0ff;
  padding-bottom: 15px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.home-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #ff9eb5;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  box-shadow: 0 2px 5px rgba(255, 158, 181, 0.3);
}

.home-btn:hover {
  background-color: #ff7a9e;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 158, 181, 0.4);
}

.home-icon {
  font-size: 16px;
}

.page-title {
  color: #6a5acd;
  font-size: 24px;
  margin: 0;
  font-weight: bold;
}

.header-actions {
  z-index: 10;
}

.new-task-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #6a5acd; /* 紫色 */
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  box-shadow: 0 2px 5px rgba(106, 90, 205, 0.3);
}

.new-task-btn:hover {
  background-color: #5544b8;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(106, 90, 205, 0.4);
}

.btn-icon {
  font-size: 16px;
}

.task-table, .page-table {
  width: calc(100% - 40px);
  border-collapse: collapse;
  margin: 20px 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.task-table th, .task-table td,
.page-table th, .page-table td {
  border: 1px solid #e0e0ff;
  padding: 12px;
  text-align: left;
}

.task-table th, .page-table th {
  background-color: #e8e8ff;
  color: #6a5acd;
  font-weight: bold;
}

.task-table tr, .page-table tr {
  cursor: pointer;
  transition: all 0.2s;
}

.task-table tr:hover, .page-table tr:hover {
  background-color: #f0f0ff;
  transform: scale(1.01);
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f5ff;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.pagination-info {
  color: #666;
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #6a5acd;
  color: white;
  border: none;
  border-radius: 15px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #5544b8;
  transform: translateY(-2px);
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-btn {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #f0f0ff;
  color: #6a5acd;
  border: 1px solid #e0e0ff;
  cursor: pointer;
  transition: all 0.3s;
}

.page-btn:hover {
  background-color: #e0e0ff;
  transform: scale(1.1);
}

.page-btn.active {
  background-color: #6a5acd;
  color: white;
  border-color: #6a5acd;
}

/* 操作按钮样式 */
.action-btn {
  padding: 6px 12px;
  margin: 0 3px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
  color: white;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.edit-btn {
  background-color: #ff9eb5; /* 粉色 */
}

.edit-btn:hover {
  background-color: #ff7a9e;
}

.summary-btn {
  background-color: #87ceeb; /* 天蓝色 */
}

.summary-btn:hover {
  background-color: #6bb6d6;
}

.delete-btn {
  background-color: #ff9999; /* 浅红色 */
}

.delete-btn:hover {
  background-color: #ff7777;
}

/* 状态样式 */
.status-已完成 {
  color: #4caf50; /* 绿色 */
  font-weight: bold;
  background-color: #e8f5e9;
  padding: 3px 8px;
  border-radius: 10px;
  display: inline-block;
}

.status-进行中 {
  color: #ff9800; /* 橙色 */
  font-weight: bold;
  background-color: #fff3e0;
  padding: 3px 8px;
  border-radius: 10px;
  display: inline-block;
}

.status-未开始 {
  color: #9e9e9e; /* 灰色 */
  font-weight: bold;
  background-color: #f5f5f5;
  padding: 3px 8px;
  border-radius: 10px;
  display: inline-block;
}

/* 公开状态样式 */
.public-true {
  color: #2196f3; /* 蓝色 */
  font-weight: bold;
  background-color: #e3f2fd;
  padding: 3px 8px;
  border-radius: 10px;
  display: inline-block;
}

.public-false {
  color: #f44336; /* 红色 */
  font-weight: bold;
  background-color: #ffebee;
  padding: 3px 8px;
  border-radius: 10px;
  display: inline-block;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* 圆角开关 */
.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

/* 禁用状态的开关样式 */
.switch-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.switch-disabled input:disabled + .slider {
  background-color: #ccc;
}

.switch-disabled input:disabled + .slider:before {
  background-color: #f5f5f5;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  padding: 15px;
}

.page-list-popup {
  max-width: 800px;
}

.dialog-content {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
}

.dialog-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.dialog-header h3 {
  margin: 0;
}

.dialog-body {
  padding: 15px;
}

.dialog-footer {
  padding: 15px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.form-container {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
}

.input-wrapper {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.form-input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  font-size: 16px;
  color: #333;
  border: none;
  background: transparent;
  box-sizing: border-box;
}

.picker-wrapper {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ddd;
  height: 40px;
  display: flex;
  align-items: center;
}

.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch-label {
  font-size: 16px;
}

/* 美观的开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #409eff;
}

input:focus + .slider {
  box-shadow: 0 0 1px #409eff;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* 表单项提示样式 */
.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  padding-left: 20px;
  position: relative;
}

.form-tip i {
  position: absolute;
  left: 0;
  top: 2px;
  color: #409eff;
  font-size: 14px;
}

/* PDF提示容器样式 */
.pdf-tip-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  background-color: #f0f7ff;
  border-left: 4px solid #409eff;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
}

.pdf-tip-container i {
  color: #409eff;
  font-size: 16px;
}

.tip-text {
  color: #606266;
}

.tip-link {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.tip-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}
</style>
